import FlexContainer from 'components/common/FlexContainer';
import { borderStyles } from 'styles/theme';
import { mobileMediaQuery } from 'utils/common';
import styled from '@emotion/styled';

export const Container = styled(FlexContainer)({
  gap: 4,
  padding: '20px 26px',
  border: `1px solid ${borderStyles.colors.primary}`,
  borderRadius: 6,
  [mobileMediaQuery]: {
    padding: 16,
  },
  flex: 1,
  alignSelf: 'stretch',
});
